export type LineItemTypeName = 'STANDARD' | 'SPONSORSHIP' | 'NETWORK' | 'BULK' | 'PRICE_PRIORITY' | 'ADSENSE' | 'AD_EXCHANGE' | 'HOUSE'

export const LINE_ITEM_TYPES: { name: LineItemTypeName; displayName: string }[] = [
  {
    name: 'STANDARD',
    displayName: 'Standard',
  },
  {
    name: 'PRICE_PRIORITY',
    displayName: 'Price Priority',
  },
  {
    name: 'SPONSORSHIP',
    displayName: 'Sponsorship',
  },
  {
    name: 'ADSENSE',
    displayName: 'AdSense',
  },
  {
    name: 'NETWORK',
    displayName: 'Network',
  },
  {
    name: 'AD_EXCHANGE',
    displayName: 'Ad Exchange',
  },
  {
    name: 'BULK',
    displayName: 'Bulk',
  },
  {
    name: 'HOUSE',
    displayName: 'House',
  },
]
